import React from 'react';

import {useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';

import {Table} from 'components/ui-kit/Table';
import {
    filtersChanged,
    Gate,
    pageNumberChanged,
    sortingChanged,
    state$,
} from 'models/documents/checks/detail/products/table';
import {commonDataState$} from 'models/documents/details';
import {ProductContentFormattedRow, ProductContentRawRow} from 'types';

interface Props {
    receiptId: string;
    configFunc: (t: TFunction) => Array<any>;
    dataMapper: (
        data: ProductContentRawRow[] | undefined,
        t: TFunction,
    ) => ProductContentFormattedRow[];
}

export const ProductsTable = ({receiptId, configFunc, dataMapper}: Props) => {
    const {t} = useTranslation();
    const {data: commonData} = useStore(commonDataState$);
    const {data, pageNumber, pageSize, sorting, filters, isLoading} = useStore(state$);
    const mappedData = React.useMemo(() => dataMapper(data, t), [dataMapper, data, t]);

    return (
        <>
            <Gate receiptId={receiptId} />
            <Table
                manualSorting
                hideSetting={true}
                columns={configFunc(t)}
                data={mappedData}
                totalRowsCount={commonData?.productsTotalCount}
                pageCount={Math.ceil((commonData?.productsTotalCount || 0) / 20)}
                pageIndex={pageNumber}
                onSortingChange={sortingChanged}
                onPageChange={pageNumberChanged}
                sorting={sorting}
                isLoading={isLoading}
                filters={filters}
                onFiltersChange={filtersChanged}
            />
        </>
    );
};
